import styled from "styled-components";

import { Text as Tx, } from "@bracket/ui";
import { SwapButton, SwapCardContainer, SwapInput, SwapInputsContainer, SwapOutput, } from "@components";



/**
 * Buy tab for brktETH: deposits are closed; layout matches the redeem card so tabs do not shift.
 */
export const BuyCard = () => {

	return (
		<SwapCardContainer>
			<InputsAnchor>
				<VisuallyHiddenInputs aria-hidden="true">
					<SwapInputsContainer>
						<SwapInput inputName="Supply LRT / LST" showUSD={false} disabled />
						<SwapOutput inputName="Receive brktETH" disabled />
					</SwapInputsContainer>
				</VisuallyHiddenInputs>
				<MessageLayer>
					<Tx color="subheading" style={{ textAlign: "center", }}>
						New brktETH deposits are no longer available. Going forward, brktETH will support redemptions only
					</Tx>
				</MessageLayer>
			</InputsAnchor>
			<VisuallyHiddenBlock aria-hidden="true">
				<SwapButton
					handleClick={() => {}}
					isDisabled
					label="Approve"
				/>
			</VisuallyHiddenBlock>
		</SwapCardContainer>
	);

};

const InputsAnchor = styled.div`
	position: relative;
`;

const VisuallyHiddenInputs = styled.div`
	visibility: hidden;
	pointer-events: none;
`;

const MessageLayer = styled.div`
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 0.5rem;
	pointer-events: none;
`;

const VisuallyHiddenBlock = styled.div`
	visibility: hidden;
	pointer-events: none;
`;
